// extracted by mini-css-extract-plugin
export default {"noBetSlipWrp":"betSlip_noBetSlipWrp__GgAH4","text2":"betSlip_text2__Vl-D1"};